import ActionsBar from 'components/ActionsBar';
import numeral from 'numeral';
import immutable from 'object-path-immutable';
import React, { Component } from 'react';
import { Badge, Col, Row } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import like from '../../../assets/img/bell.png';
import Button from '../../../components/CustomButton/CustomButton';

import * as K from '../redux/QuotationsConstants';

class packages extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openConfirm: false,
      indexToDelete: 0,
    };
  }

  handleEdit = (index) => {
    var newQuotation = immutable.set(
      this.props.Quotations,
      ['indexToEdit'],
      index
    );
    newQuotation = immutable.set(
      newQuotation,
      ['dataToEdit', 'packages'],
      this.props.Quotations.packages[index]
    );

    this.props.dispatch({
      type: K.SETSTATE,
      payload: newQuotation,
    });

    this.props.dispatch({
      type: K.OPEN_MODAL_ADD,
      payload: 'packages',
    });
  };

  handleDelete(confirm = false, index) {
    if (confirm) {
      var newArray = immutable.del(this.props.Quotations, [
        'packages',
        this.state.indexToDelete,
      ]);
      this.props.dispatch({
        type: K.SETSTATE,
        payload: newArray,
      });
      this.setState({ openConfirm: false });
    } else {
      this.setState({ openConfirm: true, indexToDelete: index });
    }
  }

  handleAdd = () => {
    this.props.dispatch({
      type: K.OPEN_MODAL_ADD,
      payload: 'packages',
    });
  };

  render() {
    const {
      Quotations: {
        packages,
        generalQuotation: { isPackage = false },
      },
    } = this.props;
    let { openConfirm } = this.state;
    return (
      <div style={{ textAlign: 'justify' }}>
        <Row>
          <Col md={12}>
            {packages.map((service, index) => {
              return (
                <div key={index} style={{ marginBottom: '30px' }}>
                  {openConfirm && (
                    <SweetAlert
                      warning
                      style={{ display: 'block', marginTop: '-100px' }}
                      title="¿Estás Seguro?"
                      onConfirm={() => this.handleDelete(true)}
                      onCancel={() => this.setState({ openConfirm: false })}
                      confirmBtnBsStyle="info"
                      cancelBtnBsStyle="danger"
                      confirmBtnText="Si, borrar!"
                      cancelBtnText="Cancelar"
                      showCancel
                    >
                      No podrás desaser está opción!
                    </SweetAlert>
                  )}
                  <ActionsBar
                    onEdit={() => this.handleEdit(index)}
                    onDelete={() => this.handleDelete(false, index)}
                  />
                  <br />
                  <Row>
                    <Col md={12}>
                      <div className="form-group">
                        {service.like !== undefined && service.like === true ? (
                          <div>
                            <img
                              src={like}
                              style={{ width: '35px', marginLeft: 0 }}
                              alt="serviceImg"
                            />
                            <span
                              style={{
                                color: '#e70a24',
                                fontSize: '15px',
                                fontWeight: 'bold',
                              }}
                            >
                              Interés
                            </span>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={3}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          NOMBRE
                        </label>
                        <br />
                        <span>{service.name}</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    {!isPackage && (
                      <React.Fragment>
                        <Col md={3}>
                          <div className="form-group">
                            <label
                              style={{ fontWeight: 'bold' }}
                              htmlFor="client"
                            >
                              COSTO DE COMPRA
                            </label>
                            <br />
                            <Badge style={{ backgroundColor: '#5FB404' }}>
                              {numeral(service.buyprice).format('$0,0.00')}
                            </Badge>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="form-group">
                            <label
                              style={{ fontWeight: 'bold' }}
                              htmlFor="client"
                            >
                              PRECIO DE VENTA
                            </label>
                            <br />
                            <Badge style={{ backgroundColor: '#0489B1' }}>
                              {numeral(service.price).format('$0,0.00')}
                            </Badge>
                          </div>
                        </Col>
                      </React.Fragment>
                    )}
                    <Col md={3}>
                      <div className="form-group">
                        <label style={{ fontWeight: 'bold' }} htmlFor="client">
                          OPERADOR
                        </label>
                        <br />
                        <span>
                          {service.operator !== null
                            ? service.operator.label
                            : ''}
                        </span>
                      </div>
                    </Col>
                  </Row>
                </div>
              );
            })}
          </Col>
        </Row>
        <Button bsStyle="primary" onClick={this.handleAdd}>
          Agregar Paquete
        </Button>
      </div>
    );
  }
}

export default connect((state) => ({ Quotations: state.Quotations }))(packages);



// WEBPACK FOOTER //
// ./src/views/Quotations/cards/packages.js